export default "__VITE_ASSET__D52FWeks__"